import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/client/anchor/partner", { offset, filter });
};

export const get = async (id: string) => {
  return httpRequest.get(`/api/client/account/${id}`);
};

export const business = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/client", { offset, filter });
};

export const select = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/client/anchor/business/select", { offset, filter });
};

export const partner = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/client/anchor/partner", { offset, filter });
};

export const sme = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/client/anchor/business/sme", { offset, filter });
};

export const partnerSelect = async (data: any) => {
  return httpRequest.get("/api/client/anchor/partner/select", data);
};

export const partnerGet = async (id: string) => {
  return httpRequest.get(`/api/client/${id}`);
};

export const businessSelect = async (data: any) => {
  return httpRequest.get("/api/client/anchor/business/select", data);
};
